import { useMutation } from '@tanstack/vue-query'

export const useSchedulePaymentCheck = () => {
  return useMutation({
    mutationFn: async ({ userId, leadId, name, packageId }: { userId: string; leadId: string; name: string; packageId?: string }) => {
      try {
        return await $fetch('/api/payment/schedule-check', {
          method: 'POST',
          body: { userId, leadId, name, packageId },
        })
      } catch (error: unknown) {
        const errorMessage = error instanceof Error ? error.message : 'Unknown error'
        throw new Error(errorMessage || 'Failed to schedule payment status check')
      }
    },
  })
}

export default useSchedulePaymentCheck
